import { AppContext, GGOBaseComponent, IconComponent, Translate } from "@galigeo-store/ui-lib";
import { css, html } from "lit";
import { GaligeoCloudService } from "../../../services/galigeo-cloud.service";
import { state } from "lit/decorators/state.js";
import { customElement } from "lit/decorators/custom-element.js";
import { MenuService } from "../../../services/menu-service";
import { PortalAppContext } from "../../../state/portal-appcontext";

@customElement('rights-admin-page')
export class RightsComponent extends GGOBaseComponent {

  static get styles() {
    return [
      ...(super.styles ?? []),
      css`
        .icon-container {
          background-color: #eeeeee;
        }
        .slds-icon {
          color: #03234d;
          width: 4rem;
          height: 4rem;
        }
        .card-title {
          padding: 1rem;
        }
        .card-container:hover {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        .card-container {
          cursor: pointer;
          max-width: 20rem;
        }
        .slds-gutters .slds-col {
          padding: 0;
          margin: 0 0.75rem;
        }
      `,
    ];
  }

  @state() private modules: any[] = [];
  private categories: any[] = [];

  constructor() {
    super();
    this.init();
  }

  async init() {
    if (PortalAppContext.isLicenseExpired()) return;
    const maps = await GaligeoCloudService.getMaps();
    this.categories = await MenuService.getCategories();
    this.modules = maps.filter((m: any) => m.type === 'module');

    for (let module of this.modules) {
      const category = this.categories.find(c => c.id === module.id);
      module.icon = category ? category.icon : undefined;
    }

    this.requestUpdate();

  }

  handleClick(moduleId: string) {
    const platformUrl = AppContext.getCurrentUser().platformUrl;
    const url = `${platformUrl}/viewer/core/#/configuration/share?url=${platformUrl}/feature/rest/services/app_${moduleId}/FeatureServer`;
    window.open(url, '_blank');
  }

  render() {
    if (PortalAppContext.isLicenseExpired()) {
      return html`
        <div style="text-align: center; margin-top: 5rem;">
          <ggo-icon icon="utility:lock" size="large" color="#c23934"></ggo-icon>
          <h2 style="margin-top: 1rem; color: #c23934;">${Translate.get('lic_expired')}</h2>
          <p style="margin-top: 0.5rem; color: #666;">${Translate.get('lic_blocked_message')}</p>
        </div>
      `;
    }

    if (this.modules.length === 0) {
      return html`<div class="slds-p-around_x-large">${Translate.get('admin_rights_no_modules')}</div>`;
    }


    return html`
     <admin-header title="${Translate.get('admin_rights_desc')}"></admin-header>
    
    <div class="slds-grid slds-p-around_x-large slds-gutters slds-wrap">${this.modules.map(module => html` 
       <ggo-card
          class="slds-col card-container"
          @click=${() => this.handleClick(module.id)}
        >
        <div class="slds-p-around_x-large icon-container">
            <ggo-icon
              icon="${module.icon || 'utility:apps'}"
              size=${IconComponent.LARGE}
              color="#03234d"
            ></ggo-icon>
          </div>
          <h2 class="card-title">Module ${module.label}</h2>
        </ggo-card>`)}</div>`;
  }
}